export const BackOfficeEnfucePayoutStateV3 = {
  BOOKED: 'BOOKED',
  CANCELLED: 'CANCELLED',
  CREATE_PAYOUT: 'CREATE_PAYOUT',
  DRAFT: 'DRAFT',
  SETTLED: 'SETTLED',
} as const

export type BackOfficeEnfucePayoutStateV3 = (typeof BackOfficeEnfucePayoutStateV3)[keyof typeof BackOfficeEnfucePayoutStateV3]

export type BackOfficePayoutCreateDtoV3 = {
  payoutType: 'ENFUCE'
  customerId: string
  amount: {
    currency: string
    value: number
  }
  [key: string]: unknown
}

export type BackOfficePayoutPatchDtoV3 = {
  state?: BackOfficeEnfucePayoutStateV3
  [key: string]: unknown
}

export type BackOfficePayoutDataResponseDtoV3 = {
  id: string
  amount: {
    currency: string
    value: number
  }
  state?: BackOfficeEnfucePayoutStateV3
  [key: string]: unknown
}
